import React from "react";
import "../../Styles/certified/bahwan.css";

export default function Finzly() {
  return (
    <>
      <div className="bahwan-certified-details-section">
        <div className="bahwan-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="bahwan-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="bahwan-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="bahwan-certified-badge"
            />
            <div className="bahwan-certified-company-names">
              <a href="https://www.bahwancybertek.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/bahwan/bahwan.jpeg"
                alt="Walkzero Logo"
                className="bahwan-certified-company-logo"
              />
            </a>
              <h1 className="bahwan-certified-full-name">
              Bahwan Cybertek India Private Limited 
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="bahwan-certified-details-right">
            <img
              src="/assets/bahwan/bahwan_1.jpg"
              alt="Finzly Office"
              className="bahwan-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="bahwan-certified-description">
          <h2>
            Why  Bahwan Cybertek India Private Limited  is an Outstanding Workplaces
          </h2>
          <p>
           Established in 1999, Bahwan CyberTek (BCT) is a global provider of digital transformation solutions in the areas of Predictive Analytics, Digital Experience and Digital Supply Chain Management, and has delivered solutions in 20 countries across North America, the Middle East, Far East, Africa and Asia. Driving innovation through outcome-based business models, proven and powerful IP solutions, BCT is a trusted partner for over 1000+ customers, including Fortune 500 companies. With strong capabilities in Digital Technologies, BCT has over 4000 associates with technical and domain expertise, delivering solutions to the Oil & Gas, Telecom, Power, Government, Banking, Retail and SCM / Logistics verticals. With a focus on joint innovation, BCT has partnered with leading global technology organizations such as TIBCO, SingleStore, Oracle, IBM and Tekion to deliver differentiated value to customers. BCT is recognized at CMMi level 5 and is an ISO certified organization.


          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="bahwan-certified-info-cards">
          <div className="bahwan-certified-info-card">
            <div className="bahwan-certified-info-title">COMPANY SIZE</div>
            <div className="bahwan-certified-info-value">2,900 Employees</div>
          </div>
          <div className="bahwan-certified-info-card">
            <div className="bahwan-certified-info-title">INDUSTRY</div>
            <div className="bahwan-certified-info-value"> IT 

</div>
          </div>
          <div className="bahwan-certified-info-card">
            <div className="bahwan-certified-info-title">CONNECT</div>
            <div className="bahwan-certified-info-icons">
              <span className="bahwan-certified-icon-round">
                <a href="https://www.bahwancybertek.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="bahwan-certified-icon-round">
                <a href="https://www.linkedin.com/company/bctglobal/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="bahwan-certified-icon-round">
                <a href="https://www.facebook.com/BCTGlobal" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="bahwan-certified-info-card">
            <div className="bahwan-certified-info-title">LOCATION (HQ)</div>
            <div className="bahwan-certified-info-value">Chennai </div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="bahwan-certified-recognition-section">
          <h2 className="bahwan-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="bahwan-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="bahwan-certified-recognition-image"
            />
          </div>
          <div className="bahwan-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="bahwan-certified-life-section">
          <h2 className="bahwan-certified-life-title">
            Life at Bahwan Cybertek India Private Limited 
          </h2>
          <div className="bahwan-certified-life-gallery">
            <div className="bahwan-certified-life-col">
              <img src="/assets/bahwan/bahwan_2.jpg" alt="Office 1" className="bahwan-certified-life-img" />
              <img src="/assets/bahwan/bahwan_3.jpeg" alt="Team 1" className="bahwan-certified-life-img" />
            </div>
            <div className="icom-certified-life-col bahwan-certified-life-center">
              <img src="/assets/bahwan/bahwan_1.jpg" alt="Main Office" className="bahwan-certified-life-img bahwan-certified-life-img-large" />
            </div>
            <div className="bahwan-certified-life-col">
              <img src="/assets/bahwan/bahwan_6.jpeg" alt="Office 2" className="bahwan-certified-life-img" />
              <img src="/assets/bahwan/bahwan_5.jpg" alt="Team 2" className="bahwan-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}